'use es6';

import configureFileManager from 'file-manager-components/configureFileManager';
import { ConfigureFileManagerFileAccess } from 'FileManagerLib/enums/FileAccess';
import UsageTracker from 'DesignManagerIde/utils/usageTracker/usageTracker';
import sharedDragDropContext from 'DesignData/lib/SharedDragDropContext';
const FileManager = configureFileManager({
  usageTracker: UsageTracker,
  withDragDropContext: false,
  withShutterstock: true,
  uploadedFileAccess: ConfigureFileManagerFileAccess.VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE
});
export default sharedDragDropContext()(FileManager);